<template>
<div id="shipping-module">

  <!-- TEMPORARILY DISABLED @CLICK WHILE NATIONAL EMERGENCY: TODO ALLOW TO DISABLE IN ADMIN -->
  <!-- The personal selection spot [if there is just a few of possibilities] -->
  <div class="form-row pfm-switch" :class="{'selected': cart.delivery.code == 'BRANCH-' + delivery.subCode}" v-for="delivery in personalPickUp" v-if="personalPickUp.length <= 3" @click="selectMethod('BRANCH-' + delivery.subCode)">
  <!-- <div class="form-row pfm-switch disabled" :class="{'selected': cart.delivery.code == 'BRANCH-' + delivery.subCode}" v-for="delivery in personalPickUp" v-if="personalPickUp.length <= 3"> -->
    <div class="shipping-header header">
      <input type="radio" :id="'pickup-' + delivery.subCode" :value="'BRANCH-' + delivery.subCode" v-model="cart.delivery.code" @change="updated()">

      <custom-pickup-info-panel :delivery="delivery" :showDetails="true" />
    </div>

    <!-- branch details... addresss and map -->
    <branch-info-panel :branch="delivery" v-if="cart.delivery.code == 'BRANCH-' + delivery.subCode" />

  </div>

  <!-- The personal selection spot [if there is a lot of possibilities] -->
  <div class="form-row pfm-switch" :class="{'selected': cart.delivery.code == 'BRANCH'}" v-if="personalPickUp.length > 3" @click="selectMethod('BRANCH')">
    <div class="shipping-header header">
      <input type="radio" id="pickup" value="BRANCH" v-model="cart.delivery.code" @change="updated('PRCATKURVA')">

      <custom-pickup-info-panel :delivery="delivery" :showDetails="false" />
    </div>
    <div class="form-row-inner" v-if="cart.delivery.code == 'BRANCH-' + delivery.subCode">

      <select @change="selectedPersonalPickupPlace" v-model="cart.delivery.code">
        <option v-for="branch in personalPickUp" :value="branch.code">{{branch.name[lang]}}</option>
      </select>

    </div>
  </div>

  <div v-for="shipping in shippingOptions">
    {{shipping.method}}
    <!-- {{JSON.stringify(shipping)}} -->
    <div class="form-row pfm-switch" :class="{'selected': cart.delivery.code == 'MESSANGER'}" v-if="shipping.code == 'MESSANGER'" @click="selectMethod('MESSANGER')">
      <div class="shipping-header header">
        <div class='radio-wrap'>
          <input type="radio" id="messenger" value="MESSANGER" v-model="cart.delivery.code" @change="updated">
          <label for="messenger" class="radio-label">{{shipping.name[lang]}}</label>
          <span class="module-price">{{getPrice(shipping)}}</span>
        </div>
      </div>
    </div>
    <div class="form-row pfm-switch" :class="{'selected': cart.delivery.code == 'PPL'}" v-if="shipping.code == 'PPL'" @click="selectMethod('PPL')">
      <div class="shipping-header header">
        <div class='radio-wrap'>
          <input type="radio" id="ppl" value="PPL" v-model="cart.delivery.code" @change="updated">
          <label for="ppl" class="radio-label">{{shipping.name[lang]}}</label>
          <span class="module-price">{{getPrice(shipping)}}</span>
        </div>
      </div>
    </div>
    <div class="form-row pfm-switch" :class="{'selected': cart.delivery.code == 'FEDEX'}" v-if="shipping.code == 'FEDEX'" @click="selectMethod('FEDEX')">
      <div class="shipping-header header">
        <div class='radio-wrap'>
          <input type="radio" id="fedex" value="FEDEX" v-model="cart.delivery.code" @change="updated">
          <label for="fedex" class="radio-label">{{shipping.name[lang]}}</label>
          <span class="module-price">{{getPrice(shipping)}}</span>
        </div>
      </div>
    </div>
    <div class="form-row pfm-switch" :class="{'selected': cart.delivery.code == 'CP'}" v-if="shipping.code == 'CP'" @click="selectMethod('CP')">
      <div class="shipping-header header">
        <div class='radio-wrap'>
          <input type="radio" id="cp" value="CP" v-model="cart.delivery.code" @change="updated">
          <label for="cp" class="radio-label">{{shipping.name[lang]}}</label>
          <span class="module-price">{{getPrice(shipping)}}</span>
        </div>
      </div>
    </div>
    <div class="form-row pfm-switch" :class="{'selected': cart.delivery.code == 'CP-OB'}" v-if="shipping.code == 'CP-OB'" @click="selectMethod('CP-OB')">
      <div class="shipping-header header">
        <div class='radio-wrap'>
          <input type="radio" id="cp-ob" value="CP-OB" v-model="cart.delivery.code" @change="updated">
          <label for="cp-ob" class="radio-label">{{shipping.name[lang]}}</label>
          <span class="module-price">{{getPrice(shipping)}}</span>
        </div>
      </div>
    </div>
    <div class="form-row pfm-switch" :class="{'selected': cart.delivery.code == 'ZASILK'}" v-if="shipping.code == 'ZASILK'" @click="selectMethod('ZASILK')">
      <div class="shipping-header header">
        <div class='radio-wrap'>
          <input type="radio" id="zasilkovna" value="ZASILK" v-model="cart.delivery.code" @change="updated">
          <label for="zasilkovna" class="radio-label">{{shipping.name[lang]}}</label>
          <span class="module-price">{{getPrice(shipping)}}</span>
        </div>
      </div>
    </div>

    <delivery-info-panel v-if="shipping.code == 'CUSTOM'"
            :cart="cart"
            :isMore="shippingOptions.length > 1 || personalPickUp.length > 0"
            :shipping="shipping"
            @click="selectMethod('CUSTOM')" />

  </div>


  <!-- Define additional shippment information -->
  <shipping-settings :cart="cart" :shopData="shopData" @updated="updated('PRCATKURVAX')" />

</div>
</template>

<script>
import Cart from '@/cart'

import Notification from '../../notification';
import Utils from '../../utils';

import ShippingSettings from './ShippingSettings';
// import ContactShipping from './ContactShipping';
import Payment from './Payment';
import CountrySelect from './CountrySelect';

import Validator from '../../service/Validator'

import CustomPickupInfoPanel from './shippingMethods/CustomPickupInfoPanel'
import DeliveryInfoPanel from './shippingMethods/DeliveryInfoPanel'
import BranchInfoPanel from './shippingMethods/BranchInfoPanel'
import CustomPlanning from './shippingMethods/CustomDeliveryPlanning'

export default {
  props: ['cart', 'shopData'],
  components: {
    ShippingSettings,
    // Contact,
    // Payment,
    // CountrySelect,
    CustomPickupInfoPanel,
    DeliveryInfoPanel,
    BranchInfoPanel,
    // CustomPlanning
  },
  data() {
    return {
      lang: Cart.lang,
      shippingOptions: [],
      personalPickUp: [],
      personalPickUpPlaceCode: '-1',
      personalPickUpPlace: null,
      methodPrices: this.shopData.methodPrices
    }
  },
  created() {
    console.log('Shipping::created', this.cart, this.shopData)

    // Setting new empty default objects
    if (this.cart.delivery == null) {
      console.log('Resetting delivery')
      Vue.set(this.cart, 'delivery', {
        params: {
          shipping: {
            country: -1,
            company: {},
            street: {}
          },
          billing: {
            shippingIsSame: false,
            company: {},
            street: {}
          }
        },
        method: -1
      })
    }
    if (this.cart.delivery.code === undefined) {
      console.log('Setting delivery code')
      Vue.set(this.cart.delivery, 'code', '')
    }

    this.filterShippings()
    this.updated();

    this.$parent.$parent.$off('updatedFromServer')
    this.$parent.$parent.$on('updatedFromServer', () => {
      this.filterShippings()
      this.updated();
    });
    this.$parent.$parent.$off('updatedCart')
    this.$parent.$parent.$on('updatedCart', () => {
      console.log('Updated cart - Shipping will react')
      this.filterShippings()
      this.updated();
    });
  },
  methods: {
    validate() {
      // this.$validator.localize('cs');
      // this.$emit('validateContact', this.validationCallBack);
      return Validator.validate()
        .then(result => {
          if (!result) {
            Notification.add('err', 'Prosím, opravte své údaje', 15)
          }
          return result
        })

    },
    validationCallBack(result) {
      // console.log('validation result', result)
    },
    getPrice(shipping) {
      if (shipping.price != null) {
        // TODO Find price for given goods dimensions
        return shipping.price[0].brutto
      } else {
        let code = shipping.subCode ? shipping.code + '-' + shipping.subCode : shipping.code
        let priceMinMax = this.methodPrices[code]
        return priceMinMax ? (priceMinMax.n != priceMinMax.x ? priceMinMax.n + '-' + priceMinMax.x : priceMinMax.n) + ' Kč' : '-'
      }
    },
    getPersonalPickupPrice() {
      if (this.personalPickUpPlace != null) {
        if (this.personalPickUpPlace.price) {
          return this.personalPickUpPlace.price[0].brutto
        } else {
          return '0'
        }
      } else {
        return ''
      }
    },
    selectMethod(methodCode) {
      console.log('Selected shipment method', methodCode)
      this.cart.delivery.code = methodCode
      Utils.scrollTo({
        targetElementId: 'shipping-module-settings'
      })
      delete this.cart.delivery['slot']
      Vue.set(this.cart.delivery, 'slot', null)

      this.updated()
    },
    selectedPersonalPickupPlace() {
      console.log('Personal pickup place code', this.personalPickUpPlaceCode)
      if (this.personalPickUpPlaceCode != -1) {
        this.personalPickUp.forEach(place => {
          if (place.code == this.personalPickUpPlaceCode) {
            this.personalPickUpPlace = place
            console.log('Personal pickup place', place, place.mapSrc)
            this.cart.delivery.price = (this.personalPickUpPlace.price != null) ? this.personalPickUpPlace.price[0] : null;
            this.updated()
          }
        })
      } else {
        this.personalPickUpPlace = null
        this.personalPickUpPlaceCode = null
      }
    },
    filterShippings() {
      console.log('Filtering shipping', this.shopData.shippings, this.cart.products.length)
      // Filter just shipping otions available for the products. If some product doesn't support given method, drop it.
      this.personalPickUp.splice(0)
      this.shippingOptions.splice(0)

      this.shopData.shippings.forEach(shipping => {
        // console.log('-- check shipping', shipping)
        let each = true
        for (let i = 0; i < this.cart.products.length; i++) {
          console.log('Checking', this.cart.products[i].snapshot.config.shipping, shipping.code, shipping.subCode)
          if (shipping.code != null && shipping.code != '') {
            each = each && this.cart.products[i].snapshot.config.shipping.delivery.includes(shipping.code)
          } else {
            each = each && this.cart.products[i].snapshot.config.shipping.delivery.includes(shipping.subCode)
          }
          // console.log('-- check shipping', shipping.code, shipping.method, each)
        }
        console.log('Is each product dispatchable the same way?', each)
        if (each) {
          if (shipping.phisical) {
            this.personalPickUp.push(shipping)
          } else {
            this.shippingOptions.push(shipping)
          }
        }
      })

      // Select default personal pickup
      if (this.shippingOptions.length == 0) {
        console.log('No regular shipping available', this.personalPickUp)
        // There is just personal pickup available, select the first one
        this.personalPickUpPlaceCode = this.personalPickUp[0].code
        this.cart.delivery.code = 'BRANCH'
        this.selectedPersonalPickupPlace()
        this.updated()
      }
      console.log('Shipping options', this.personalPickUp, this.shippingOptions)
      if (this.shippingOptions.length == 1 && this.personalPickUp.length == 0) {
        console.log('Sellecting default shipping method', this.shippingOptions[0].code)
        this.cart.delivery.code = this.shippingOptions[0].code
      } else if (this.shippingOptions.length == 0 && this.personalPickUp.length > 0) {
        console.log('Sellecting default shipping method', this.personalPickUp[0])
        this.cart.delivery.code = this.personalPickUp[0].code + (this.personalPickUp[0].subCode ? '-' + this.personalPickUp[0].subCode : '')
      }
    },
    slotSelected(slot) {
      console.log('Slected delivery slot', slot)


    },
    updated() {
      this.$emit('updated');
    }
  }
}
</script>

<style lang='less'>
@import '../../variables.less';

.place-info-wrapper {
  padding: 0px 20px 20px 20px;
  color: @pfm-cart-color-form-switch-text-selected;
}
.place-info-map {
  padding: 2px;
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
  overflow: hidden;
}
</style>
